import { PersonEntity } from "../Person/PersonEntity"
import { BaseModel } from "../Generics/BaseModel"
import { EOldType } from "../../Enum/EOldType"
import { ECustomerPaymentType } from "../../Enum/ECustomerPaymentType"
import { AwardManagerEntity } from "../Awards/AwardManagerEntity"

export class CustomerEntity extends BaseModel {
  id: number

  personEntity: PersonEntity

  oldType: EOldType

  status: ECustomerPaymentType

  awardsIds: number[]

  awardManagers: AwardManagerEntity[]

  isSystemDefault: boolean

  constructor(data: Partial<CustomerEntity> = {}) {
    super()

    this.status = data.status ?? ECustomerPaymentType.WithOutDebit

    this.id = data.id ?? -1

    this.personEntity = new PersonEntity(data.personEntity)

    this.oldType = data.oldType ?? EOldType.IsAdult

    this.awardManagers = (data.awardManagers ?? []).map((e) => new AwardManagerEntity(e))

    this.awardsIds = data.awardsIds ?? []

    this.isSystemDefault = data.isSystemDefault ?? false
  }

  get isDefaultCustomer(): boolean {
    return this.isSystemDefault || this.personEntity?.cpf === "00000000000"
  }
}
